import {padZeros} from '@stubhub/dateformat-utils';
import {TIME} from '@stubhub/general-utils';

import {K_ALL, K_CHOOSE, K_THIS_MONTH, K_THIS_WKD, K_TODAY} from './utils';

const keyMap = {
  t: K_TODAY,
  w: K_THIS_WKD,
  m: K_THIS_MONTH,
  c: K_CHOOSE,
  a: K_ALL,
};

const keyToParameter = {
  [K_TODAY]: 't',
  [K_THIS_WKD]: 'w',
  [K_THIS_MONTH]: 'm',
  [K_CHOOSE]: 'c',
  [K_ALL]: 'a',
};

const getKey = (letter) => (keyMap[letter] ? keyMap[letter] : K_ALL);

export const qualifiedDate = (param) => {
  if (!param || param.length === 1) {
    return {key: getKey(param)};
  }

  const tokens = param.match(/([0-9]{4}(-[0-9]{1,2}){2})to([0-9]{4}(-[0-9]{1,2}){2})/);
  if (!tokens || tokens.length !== 5) {
    return {key: K_ALL};
  }

  const [, startDate] = tokens;
  const startSplit = startDate.split('-');
  const [, , , endDate] = tokens;
  const endSplit = endDate.split('-');
  const offset = new Date().getTimezoneOffset() / TIME.MINS_OF_HOUR;
  const start = new Date(
    Date.UTC(
      parseInt(startSplit[0], 10),
      parseInt(startSplit[1], 10) - 1,
      parseInt(startSplit[2], 10),
      0 + offset,
      0,
      0
    )
  );
  const end = new Date(
    Date.UTC(
      parseInt(endSplit[0], 10),
      parseInt(endSplit[1], 10) - 1,
      parseInt(endSplit[2], 10),
      TIME.HOURS_OF_DAY - 1,
      TIME.MINS_OF_HOUR - 1,
      TIME.SECONDS_OF_MIN - 1
    )
  );

  return {key: K_CHOOSE, start, end};
};

export const dateParam = ({key, start, end}) => {
  if (key === K_ALL || !key) {
    return keyToParameter[K_ALL];
  }
  if (key !== K_CHOOSE) {
    return keyToParameter[key] || keyToParameter[K_ALL];
  }
  const startDate = new Date(start);
  const startDay = startDate.getDate();
  const startMonth = startDate.getMonth();
  const startYear = startDate.getFullYear();
  const endDate = new Date(end);
  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth();
  const endDay = endDate.getDate();

  return `${startYear}-${padZeros(startMonth + 1, 2)}-${padZeros(startDay, 2)}to${endYear}-${padZeros(
    endMonth + 1,
    2
  )}-${padZeros(endDay, 2)}`;
};
